/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import StyledLabelWithRequired from '../../../components/styled/StyledLabelWithRequired';
import { ReactElement } from 'react';

import { styled } from 'styled-components';
import { useAppSelector } from '../../../common/redux/hooks';
import { ContractorDocuments } from '../../../common/types';
import StyledButton from '../../../components/styled/StyledButton';

interface DocumentCardProps {
    label: string;
    icon: string;
    toolTip?: ReactElement;
    name: string;
    isRequired?: boolean;
    handleClick: () => void;
    done?: boolean;
    subText?: string;
}
interface LabelDivProps {
    hasToolTip?: boolean;
}

export default function DocumentCard({
    label,
    icon,
    name,
    isRequired = true,
    done = false,
    handleClick,
    subText,
}: DocumentCardProps): ReactElement {
    const documents = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.documents
    );
    return (
        <StyledCard>
            <StyledLabelContainer>
                <StyledIcon className={icon} />
                <div>
                    <StyledLabelWithRequired
                        label={label}
                        required={isRequired}
                        optional={!isRequired}
                    />
                    {subText && <StyledSubText>{subText}</StyledSubText>}
                </div>
            </StyledLabelContainer>
            {documents[name as keyof ContractorDocuments]?.length || done ? (
                <StyledButton variant='tertiary' onClick={handleClick}>
                    <StyledCircleCheck className='fa fa-check-circle-o' />
                    <span>Uploaded</span>
                </StyledButton>
            ) : (
                <StyledButton variant='tertiary' onClick={handleClick}>
                    Upload
                </StyledButton>
            )}
        </StyledCard>
    );
}

const StyledCard = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    margin-top: 10px;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray500};
    button {
        width: 148px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

const StyledIcon = styled.i`
    color: ${({ theme }) => theme.colors.blue400};
    width: 20px;
    height: auto;
`;

const StyledCircleCheck = styled.i`
    font-size: ${({ theme }) => theme.fontSizes[16]};
    margin-right: 5px;
`;

const StyledLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const StyledSubText = styled.div`
    margin-top: 4px;
    font-size: 14px;
    color: ${({ theme }) => theme.color('grey600')};
`;

const StyledLabelDiv = styled.div<LabelDivProps>`
    ${props => props.hasToolTip && 'margin-left: 10px;'}
`;
